import React from 'react';
import RecompenseGlanceCard from './RecompenseGlanceCard';
import { MANAGE_RECOMPENSES_CTA } from '../../utils/recompenseProgrammeMirror';

/**
 * Coup d’œil récompenses — cartes réelles + lien gérer.
 */
export default function RecompenseProgrammeMirror({ mirror, onManageRecompenses }) {
  if (!mirror || mirror.status === 'loading') {
    return (
      <section
        className="rounded-2xl border border-gray-200 bg-white p-4 space-y-3"
        data-testid="recompense-programme-mirror"
      >
        <h3 className="text-base font-semibold text-gray-900">Vos récompenses en un coup d’œil</h3>
        <p className="text-sm text-gray-500">Chargement des récompenses…</p>
      </section>
    );
  }

  const rows = Array.isArray(mirror.glanceRows) ? mirror.glanceRows : [];

  return (
    <section
      className="rounded-2xl border border-gray-200 bg-white p-4 space-y-3"
      data-testid="recompense-programme-mirror"
    >
      <h3 className="text-base font-semibold text-gray-900">Vos récompenses en un coup d’œil</h3>

      {mirror.status === 'error' && (
        <p className="text-sm text-amber-800 bg-amber-50 rounded-lg px-3 py-2">{mirror.errorMessage}</p>
      )}

      {mirror.status === 'ok' && mirror.empty && (
        <div className="rounded-xl bg-gray-50 px-3 py-3 space-y-1">
          <p className="text-sm font-medium text-gray-900">{mirror.emptyTitle}</p>
          <p className="text-sm text-gray-600">{mirror.emptyBody}</p>
        </div>
      )}

      {mirror.status === 'ok' && !mirror.empty && (
        <div className="space-y-3">
          {mirror.noActiveHint && <p className="text-sm text-gray-600">{mirror.noActiveHint}</p>}
          {mirror.multiActive && mirror.clientChoiceNotReadyHint && (
            <p className="text-xs text-gray-500" data-testid="recompense-mirror-multi-active">
              {mirror.multiActivePhrase ? `${mirror.multiActivePhrase}. ` : ''}
              {mirror.clientChoiceNotReadyHint}
            </p>
          )}
          <div className="flex flex-wrap gap-2.5">
            {rows.map((row, index) => (
              <RecompenseGlanceCard key={row.id || index} recompense={row} index={index} />
            ))}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => onManageRecompenses?.()}
        className="inline-flex items-center gap-1 text-sm font-medium text-[#4A148C] hover:underline"
        data-testid="manage-recompenses-cta"
      >
        {MANAGE_RECOMPENSES_CTA}
        <span aria-hidden>→</span>
      </button>
    </section>
  );
}
